/* istanbul ignore file */
import axios from 'axios';
import { getApiBaseUrl } from 'helpers/api';

const baseUrl = getApiBaseUrl();
const TIME_OUT = 30000;

const axiosFormDataInstance = axios.create({
  baseURL: baseUrl,
  timeout: TIME_OUT,
  headers: {
    'Content-Type': 'multipart/form-data',
    ContentType: 'multipart/form-data',
    Accept: '*/*',
    'Access-Control-Allow-Origin': '*',
  },
});

axiosFormDataInstance.interceptors.request.use(
  (config) => {
    if (!config.headers.token) {
      const token = localStorage.getItem('token');

      if (token) {
        config.headers.Authorization = token;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosFormDataInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 498) {
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  },
);

export default axiosFormDataInstance;
